// extracted by mini-css-extract-plugin
module.exports = {"root":"InputDescription-root-59c7544127b704cb9ee707dc3063398b"};